import { createStore } from '@/utils/createStore'

export interface Invoice {
  id: string
  invoiceNumber: string
  type: 'generator' | 'consumer'
  entity: string
  entityId?: string          // generator / consumer id
  allocationId?: string      // the unit-allocation this invoice was raised from
  period: string
  units?: number             // billed quantity (kWh)
  tariff?: number            // rate per unit (₹/kWh)
  sac?: string               // HSN / SAC code
  placeOfSupply?: string
  baseAmount: number
  cgstAmount?: number
  sgstAmount?: number
  igstAmount?: number
  gstAmount: number
  totalAmount: number
  paidAmount: number
  status: 'draft' | 'submitted' | 'rejected' | 'issued' | 'partially_paid' | 'paid' | 'overdue' | 'cancelled'
  dueDate: string
  irn: string | null
  ewayBill: string | null
  gstr1Filed: boolean
  gstr3bFiled: boolean
  issueDate: string
  // ── Bill-to details (snapshot at issue time) ──
  clientGstNo?: string
  clientAddress?: string[]
  customerRef?: string       // HTSC / service number shown as "Customer ID"
  reverseCharge?: boolean
  notes?: string
}

export const invoiceStore = createStore<Invoice>('sp_invoices', [], 'INV', 5, '/invoices')
